import React from 'react';
import '../css/Login.css';

export default class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checkBox: true,
            messageDisplay: 'none',
            passwordDisplay: 'password'
        }
    }

    handleChange() {
        if (this.state.checkBox) {
            this.setState({
                checkBox: false,
                messageDisplay: 'block'
            })
        } else {
            this.setState({
                checkBox: true,
                messageDisplay: 'none'
            })
        }
    }

    showPassBtnStyle = {
        fontSize: '100%',
        background: 'none',
        border: 'none'

    }

    showPassword(type) {
        if (type === 'password') {
            this.setState({
                passwordDisplay: 'text'
            })
        } else if (type === 'text') {
            this.setState({
                passwordDisplay: 'password'
            })
        }
    }

    renderUserLogin() {
        // const checkBoxMsgStyle = {
        //     display: this.state.messageDisplay
        // }

        return (
            // User Login Form
            <div className="login-page app-page" id="user-login-page">

                {/* <button id="install-btn">Save page to phone!</button> */}

                {/* Register button */}
                {/* <button onClick={() => { this.props.goToRegister(); }} id="goto-register-btn">Register ></button> */}

                {/* Login Form */}
                <div id="login-img-container">
                    <img alt="cuppy-login-logo" id="login-logo" src="https://s3-us-west-2.amazonaws.com/cuppy-assets/logo.png" />
                </div>

                <div id="login-form-container">
                    <label htmlFor="username">Email</label>
                    <input autoComplete="off" ref="loginUsername" className="login-input" type="text" placeholder="Enter Email" name="username" required></input>

                    <label htmlFor="password">Password</label>
                    <input ref="loginPassword" className="login-input" type={this.state.passwordDisplay} placeholder="Enter Password" name="password" required></input>

                    {/* <label>
                        <input type="checkbox" defaultChecked="checked" name="remember-me"></input> Remember Me
                    </label> */}

                    {/* <label id="terms">
                        <input id="terms-checkbox" type="checkbox" defaultChecked="checked" onChange={() => {this.handleChange()}} name="tc"></input> I have read and agree to the&nbsp;
                        <a href="https://www.cuppy.ca/termsconditions" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>
                    </label>

                    <div id="checkbox-msg" style={checkBoxMsgStyle}>
                        Please agree to the terms &amp; conditions before continuing.
                    </div> */}

                    <button style={this.showPassBtnStyle} id="show-password-btn" onClick={() => {
                        let type = this.refs.loginPassword.type;
                        this.showPassword(type)
                    }}>Show Password</button>

                    <button onClick={() => {
                        let username = this.refs.loginUsername.value.trim();
                        let password = this.refs.loginPassword.value;
                        this.props.userLogin(username, password);
                    }} className="login-btn" type="submit">Login</button>

                    {/* <button onClick={() => {
                        if (this.state.checkBox) {
                            let username = this.refs.loginUsername.value;
                            let password = this.refs.loginPassword.value;
                            this.props.registerUser(username, password);
                        } else {
                            this.setState({
                                checkBox: false,
                                messageDisplay: 'block'
                            })
                        }                            
                    }} className="register-btn" type="submit">Register</button> */}
                </div>

                <div id="login-message-container">{this.props.loginMessage}</div>

                {/* Switch to Vendor Login */}
                <button onClick={() => { this.props.switchVendorLogin(); }} id="switch-login-btn">VENDOR LOGIN ></button>
                <div className="vers">vers. 0.6.0</div>
            </div>
        )
    }

    renderVendorLogin() {
        return (
            // Vendor Login Page
            <div className="login-page app-page" id="vendor-login-page">
                <div id="vendor-login-header">VENDOR LOGIN</div>

                <div id="login-img-container">
                    <img alt="cuppy-login-logo" id="login-logo" src="https://s3-us-west-2.amazonaws.com/cuppy-assets/logo.png" />
                </div>

                <div id="login-form-container">

                    <label htmlFor="username">Username</label>
                    <input autoComplete="off" ref="vendorLoginUser" className="login-input" type="text" placeholder="Enter Username" name="username" required></input>

                    <label htmlFor="password">Password</label>
                    <input ref="vendorLoginPass" className="login-input" type={this.state.passwordDisplay} placeholder="Enter Password" name="password" required></input>

                    {/* <label>
                        <input type="checkbox" defaultChecked="checked" name="remember-me"></input> Remember Me
                    </label> */}

                    <button style={this.showPassBtnStyle} id="show-password-btn" onClick={() => {
                        let type = this.refs.vendorLoginPass.type;
                        this.showPassword(type)
                    }}>Show Password</button>

                    <button onClick={() => {
                        let username = this.refs.vendorLoginUser.value;
                        let password = this.refs.vendorLoginPass.value;
                        this.props.vendorLogin(username, password);
                    }} className="login-btn" id="vendor-login-btn" type="submit">Login</button>
                </div>

                <div id="login-message-container">{this.props.loginMessage}</div>

                {/* Switch to User Login */}
                <button onClick={() => { this.props.switchUserLogin(); }} id="switch-login-btn">USER LOGIN ></button>
                <div className="vers">vers. 0.6.0</div>
            </div>
        )
    }

    render() {
        if (this.props.loginType === 'user') {
            return this.renderUserLogin();
        } else if (this.props.loginType === 'vendor') {
            return this.renderVendorLogin();
        }
    }
}

